module.exports = __webpack_public_path__ + "fonts/IQOS-Bold.f2a15bf.woff";